export function moveItem<X>(arr: X[], from: number, to: number): X[] {
    if (to < 0 || to >= arr.length || from === to) return arr;
    const copy = [...arr];
    const [item] = copy.splice(from, 1);
    copy.splice(to, 0, item);
    return copy;
}
